/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelDiamondIcon20Solid = forwardRef('JewelDiamondIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.254 2.004H5.5a2.05 2.05 0 0 0-1.673.865l-2.72 3.838A2.056 2.056 0 0 0 .936 7h4.178l2.14-4.996Z" }),
        React.createElement("path", { d: "M.824 8.5c.088.284.239.553.452.783l7.698 8.333a1.396 1.396 0 0 0 2.052 0l7.698-8.333c.213-.23.364-.499.452-.783h-4.094l-4.424 8.109a.75.75 0 0 1-1.316 0l-4.424-8.11H.824Z" }),
        React.createElement("path", { d: "M19.064 7a2.054 2.054 0 0 0-.173-.293l-2.719-3.838a2.05 2.05 0 0 0-1.673-.865h-1.753L14.887 7h4.177Z" }),
        React.createElement("path", { d: "M11.114 2.004 13.255 7h-6.51l2.14-4.996h2.23Z" }),
        React.createElement("path", { d: "M10 14.684 6.627 8.5h6.746L10 14.684Z" })));
});
